var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disision"},[_c('el-cascader',{attrs:{"expand-trigger":"hover","options":_vm.options,"props":_vm.props,"change-on-select":true,"show-all-levels":false},on:{"change":_vm.handleChange},model:{value:(_vm.selectedOptions2),callback:function ($$v) {_vm.selectedOptions2=$$v},expression:"selectedOptions2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }